<template>
  <div class="introducer-report-list">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-date"></i> Introducer Summary</span>
        <div style="float: right"></div>
      </div>

      <el-form :inline="true" size="medium">
        <el-form-item label="Year">
          <el-select
            v-model="query.year"
            placeholder="Year"
            style="width: 100px"
          >
            <el-option
              v-for="item in year_option"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            :loading="loading"
            @click="getSummary()"
            >Query</el-button
          >
          <el-button
            icon="el-icon-download"
            type="success"
            @click="ExcelReport()"
            >Excel</el-button
          >
        </el-form-item>
      </el-form>

      <div class="table-area" v-loading="loading">
        <data-tables
          v-if="dataTable.length > 0"
          :data="dataTable"
          border
          :page-size="20"
          :pagination-props="{
            background: true,
            pageSizes: [20, 50, 100, 200],
          }"
        >
          <el-table-column
            prop="member_code"
            label="Introducer Code"
            header-align="center"
            align="center"
            width="150"
            fixed="left"
          >
          </el-table-column>
          <el-table-column
            prop="customer_name"
            label="Customer Name"
            header-align="center"
            align="center"
            min-width="150"
          >
          </el-table-column>
          <el-table-column
            prop="project_name"
            label="Project Name"
            header-align="center"
            align="center"
            min-width="250"
          >
          </el-table-column>
          <el-table-column
            prop="first_introduced"
            label="First Introduced"
            header-align="center"
            align="center"
            min-width="120"
          >
          </el-table-column>

          <el-table-column
            prop="jan"
            label="Jan"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="feb"
            label="Feb"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="mar"
            label="Mar"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="apr"
            label="Apr"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="may"
            label="May"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="jun"
            label="Jun"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="jul"
            label="Jul"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="aug"
            label="Aug"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="sep"
            label="Sep"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="oct"
            label="Oct"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="nov"
            label="Nov"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="dec"
            label="Dec"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="total"
            label="Total"
            header-align="center"
            align="center"
            fixed="right"
          >
          </el-table-column>
        </data-tables>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { currentYear } from "@/utils";
import { getIntroducerSummaryProject, reportIntroducerSummaryExcel } from "@/api/introducer";
export default {
  props: {
    project: String,
  },
  computed: {
    ...mapGetters(["user_project", "company_uid"]),
  },
  watch: {
    project(val, old) {
      this.project_uid = val;
      this.getSummary();
    },
  },
  data() {
    return {
      loading: false,
      project_uid: this.project,
      dateSearch: "",
      dataTable: [],
      year_option: [],
      query: {
        year: currentYear(),
      },
    };
  },
  methods: {
    getSummary() {
      this.loading = true;
      getIntroducerSummaryProject(this.project_uid, this.query).then(
        ({ result, data }) => {
          this.loading = false;
          if (result) {
            this.dataTable = data;
          }
        }
      );
    },
    dropdownMonthYear() {
      for (let y = 2019; y <= currentYear(); y++) {
        this.year_option.push({ value: y.toString() });
      }
    },
    ExcelReport() {
      reportIntroducerSummaryExcel(this.project_uid, this.query);
    },
  },
  mounted() {
    this.project_uid = this.project || this.user_project;
    this.dropdownMonthYear();
  },
};
</script>

<style lang="scss">
.introducer-report-list {
  .table-area {
    min-height: 200px;
  }
}
</style>